import React from 'react';
import { Link } from 'react-router-dom';
import InstitutionStudentForm from './form/InstitutionStudentForm';

function InstitutionStudentSignUpForm() {
  return (
    <>
      <div className="text-center mb-7">
        <h3 className="text-body-highlight">Sign Up</h3>
        <p className="text-body-tertiary">
          Register to apply for jobs and connect with employers
        </p>
      </div>
      <InstitutionStudentForm />
      <div className="text-center">
        <Link to="/sign-in" className="fs-9 fw-bold">
          Sign in to an existing account
        </Link>
      </div>
    </>
  );
}

export default InstitutionStudentSignUpForm;
